import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { copyElement, deleteElement, pasteElement } from "@/store/slideEditorSlice";
import { useEffect } from "react";

export function useSlideEditorShortcuts() {
  const dispatch = useAppDispatch();
  const { slide, selectedId } = useAppSelector((state) => state.slideEditor.present);

  const selectedElement = slide?.elements.find((el) => el.id === selectedId);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check if user is typing in an input field
      const target = e.target as HTMLElement;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return;
      }

      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      const modifier = isMac ? e.metaKey : e.ctrlKey;

      // Copy: Ctrl/Cmd + C
      if (modifier && e.key === "c" && selectedElement) {
        e.preventDefault();
        dispatch(copyElement(selectedElement));
      }

      // Paste: Ctrl/Cmd + V
      if (modifier && e.key === "v") {
        e.preventDefault();
        dispatch(pasteElement());
      }

      // Duplicate: Ctrl/Cmd + D
      if (modifier && e.key === "d" && selectedElement) {
        e.preventDefault();
        dispatch(copyElement(selectedElement));
        dispatch(pasteElement());
      }

      // Delete: Delete or Backspace
      if (e.key === "Delete" && selectedId) {
        e.preventDefault();
        dispatch(deleteElement(selectedId));
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [dispatch, selectedId, selectedElement]);
}
